// src/pages/blackFriday/CadastroPlus.js — cadastro do PLUS na Black Friday (out/26).
//
// Do Claude Design ("Cadastro Plus Black Friday.dc.html"): o /register?plan=plus
// vira a página da oferta — título BLACK FRIDAY gigante que derrete com a
// contagem, as duas fitas cruzadas, o formulário em 4 etapas e, ao lado, o
// resumo do Plus. Aparece só com o plano PLUS e a campanha ligada
// (campanha.CAMPANHA_LIGADA); fora disso o Register.js mostra o cadastro comum.
//
// O miolo (etapas, cartão, formulário) é o MESMO do cadastro comum
// (cadastro/TelaCadastro.js); aqui ficam só o topo e o resumo da oferta.
// Estado e handlers continuam no Register.js e chegam por props.
import TelaCadastro, { chaveRecurso, NotaCobranca, Recurso } from '../cadastro/TelaCadastro';
import { dois, rotuloContagem, useContagem } from './campanha';
import './cadastroPlus.css';

// Uma fita = o mesmo trecho repetido 8 vezes; a animação anda metade (4
// repetições) e volta ao começo sem emenda aparecer.
function Fita({ className, children }) {
  return (
    <div className={`cbf-fita ${className}`}>
      <div className="cbf-fita-trilho">
        {Array.from({ length: 8 }, (_, i) => <span key={i} className="cbf-fita-trecho">{children}</span>)}
      </div>
    </div>
  );
}

function Topo({ tempo, derrete, preco, testeDisponivel }) {
  const { d, h, m, s } = tempo;
  return (
    <section className="cbf-hero" aria-labelledby="cbf-titulo">
      <div className="cbf-hero-brilho" aria-hidden="true" />
      <div className="cbf-hero-in">
        <p className="cad-sobretitulo">Cetto System — Cadastro</p>
        <div className="cbf-titulo-caixa">
          <h1 id="cbf-titulo" className="cbf-titulo" style={derrete}>
            <span>BLACK</span>
            <span>FRIDAY</span>
          </h1>
          <span className="cbf-adesivo">Plano Plus</span>
        </div>
        <p className="cbf-oferta">Até 3 números na API Oficial por <b>{preco}</b></p>
        <div className="cbf-relogio" role="timer" aria-label={rotuloContagem(tempo)}>
          <span className="cbf-relogio-rot">Termina em</span>
          <div className="cbf-relogio-casas" aria-hidden="true">
            <span className="cbf-casa"><b>{d}</b><span>dias</span></span>
            <span className="cbf-casa"><b>{dois(h)}</b><span>horas</span></span>
            <span className="cbf-casa"><b>{dois(m)}</b><span>min</span></span>
            <span className="cbf-casa cbf-casa-seg"><b>{dois(s)}</b><span>seg</span></span>
          </div>
        </div>
      </div>

      <div className="cbf-fitas" aria-hidden="true">
        <Fita className="cbf-fita-verde">
          <span className="cbf-fita-bf">Black Friday</span><i>✦</i>
          <span>Até 3 números na API Oficial</span><i>✦</i>
          <span>{preco}</span><i>✦</i>
        </Fita>
        <Fita className="cbf-fita-branca">
          <span>Oferta</span>
          <span className="cbf-fita-bf">Black Friday</span><i>—</i>
          {/* Quem já teve assinatura não ganha o teste de novo. */}
          <span>{testeDisponivel ? '7 dias grátis' : 'Cancele pelo painel'}</span><i>—</i>
          <span>API Oficial da Meta</span><i>—</i>
        </Fita>
      </div>
    </section>
  );
}

function ResumoOferta({ tempo, derrete, plano, testeDisponivel }) {
  const { d, h, m, s } = tempo;
  return (
    <aside className="cad-resumo" aria-label="Resumo da oferta">
      <div className="cbf-resumo-faixa">
        <p className="cbf-resumo-selo">
          <span className="cbf-resumo-oferta"><span aria-hidden="true">🔥 </span>OFERTA</span>
          <span className="cbf-resumo-bf" style={derrete}>BLACK FRIDAY</span>
        </p>
        <p className="cbf-resumo-tempo" role="timer" aria-label={rotuloContagem(tempo)}>
          Termina em <b aria-hidden="true">{d}d {dois(h)}h {dois(m)}m {dois(s)}s</b>
        </p>
      </div>
      <div className="cad-resumo-corpo">
        <p className="cbf-resumo-plano">Plano {plano.name}</p>
        <p className="cbf-resumo-preco">
          <span style={derrete}>{plano.price}</span>
          <span>{plano.priceUnit}</span>
        </p>
        <ul className="cad-recursos">
          {plano.features.map((f) => <Recurso key={chaveRecurso(f)} recurso={f} />)}
        </ul>
        <NotaCobranca testeDisponivel={testeDisponivel} />
      </div>
    </aside>
  );
}

export default function CadastroPlus({ plano, ...props }) {
  const tempo = useContagem();
  const derrete = { fontVariationSettings: `'YEAR' ${tempo.ano}` };
  const preco = `${plano.price}${plano.priceUnit}`;
  return (
    <TelaCadastro
      {...props}
      classe="cad-bf"
      tituloAba="Black Friday · Plano Plus | Cetto System"
      nivelEtapa="h3"
      plano={plano}
      topo={<Topo tempo={tempo} derrete={derrete} preco={preco} testeDisponivel={props.testeDisponivel} />}
      cabecalho={(
        <div className="cbf-cad-cab">
          <h2 id="cad-cad-titulo">Sua operação blindada começa aqui</h2>
          <p>API Oficial Meta · Sem campos técnicos · Ativação em minutos</p>
        </div>
      )}
      resumo={<ResumoOferta tempo={tempo} derrete={derrete} plano={plano} testeDisponivel={props.testeDisponivel} />}
    />
  );
}
